export const reviews = [
  {
    id: 1,
    author: '吃瓜一线猹',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20person%20portrait%2C%20stylish%20casual%20look%2C%20simple%20dark%20background%2C%20professional%20headshot%20style%2C%20soft%20lighting&width=200&height=200&seq=avatar-01&orientation=squarish',
    rating: 5,
    headline: '全网最快最全的爆料平台',
    content: '关注爆料网已经一年多了，真的是全网更新最快的平台。每次有什么大瓜爆出来，这里都是第一时间推送。而且内容质量很高，不是那种捕风捉影的假料。推荐给了好多朋友！',
    date: '2026-06-25',
    userType: '资深用户',
  },
  {
    id: 2,
    author: '娱乐圈观察者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20media%20person%20portrait%2C%20confident%20expression%2C%20simple%20dark%20background%2C%20editorial%20photography%20style%2C%20clean%20lighting&width=200&height=200&seq=avatar-02&orientation=squarish',
    rating: 5,
    headline: '做媒体这行每天必刷的网站',
    content: '作为娱乐媒体从业者，爆料网是我每天早上打开电脑必看的第一个网站。信息整理得很好，分类清晰，找特定类型的爆料非常方便。很多独家内容比我们这些专业媒体的消息还快。',
    date: '2026-06-20',
    userType: '媒体从业者',
  },
  {
    id: 3,
    author: '吃瓜小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Fashionable%20young%20Chinese%20girl%20portrait%2C%20trendy%20style%2C%20simple%20dark%20background%2C%20casual%20headshot%2C%20natural%20lighting&width=200&height=200&seq=avatar-03&orientation=squarish',
    rating: 4,
    headline: '吃瓜群众的天堂！就是想要个APP',
    content: '内容没得说，真的很全很及时。唯一的遗憾就是还没有APP，只能网页浏览。跪求出一个手机APP啊！如果可以推送通知就更好了，这样就不会错过任何大瓜了。',
    date: '2026-06-18',
    userType: '活跃用户',
  },
  {
    id: 4,
    author: '理性吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20man%20portrait%2C%20intellectual%20look%2C%20simple%20dark%20background%2C%20professional%20headshot%2C%20soft%20dramatic%20lighting&width=200&height=200&seq=avatar-04&orientation=squarish',
    rating: 5,
    headline: '分析深入，不只是表面爆料',
    content: '和其他爆料平台不同，爆料网不仅提供事件的基本信息，还会做深度分析和追踪报道。每篇文章都有理有据，不会为了博眼球而夸大事实。这种专业态度在娱乐资讯领域很难得。',
    date: '2026-06-15',
    userType: '行业分析师',
  },
  {
    id: 5,
    author: '夜猫子小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%2C%20casual%20streetwear%20style%2C%20simple%20dark%20background%2C%20natural%20headshot%2C%20warm%20lighting&width=200&height=200&seq=avatar-05&orientation=squarish',
    rating: 5,
    headline: '每天睡前必刷，吃瓜吃到停不下来',
    content: '自从室友推荐了这个网站，我每天睡前都要刷一个小时。爆料内容的丰富程度真的超乎想象，从网红到明星到社会热点什么都有。而且更新特别勤快，半夜都能看到新内容！',
    date: '2026-06-12',
    userType: '忠实粉丝',
  },
  {
    id: 6,
    author: '公关人小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%2C%20business%20casual%20look%2C%20simple%20dark%20background%2C%20corporate%20headshot%2C%20clean%20lighting&width=200&height=200&seq=avatar-06&orientation=squarish',
    rating: 4,
    headline: '公关行业的风向标，危机预警必备',
    content: '做公关这一行的，信息差就是一切。爆料网是我们团队的重要信息源，很多舆情事件的苗头都是在这里先看到的。速度快、覆盖面广，帮我们成功预警了好几次潜在的公关危机。',
    date: '2026-06-10',
    userType: '公关从业者',
  },
];

export const mediaReviews = [
  {
    id: 1,
    author: '新娱乐周刊',
    avatar: '',
    rating: 5,
    headline: '娱乐资讯领域的一匹黑马',
    content: '爆料网以其独特的视角和极快的更新速度，在娱乐资讯领域迅速崛起。其深度报道和独家爆料的质量已经达到了专业媒体水准，堪称行业新标杆。',
    date: '2026-05-20',
    userType: '合作媒体',
  },
  {
    id: 2,
    author: '数字媒体观察',
    avatar: '',
    rating: 5,
    headline: '用户体验最好的吃瓜平台',
    content: '在众多娱乐资讯平台中，爆料网的界面设计和内容组织是最出色的。分类清晰，搜索方便，阅读体验流畅。推荐算法也做得很不错，能准确推送用户感兴趣的内容。',
    date: '2026-05-15',
    userType: '合作媒体',
  },
  {
    id: 3,
    author: '互联网评论家',
    avatar: '',
    rating: 4,
    headline: '内容质量把控值得称赞',
    content: '在信息爆炸的时代，爆料网坚持对每一条信息进行核实后再发布，这种负责任的态度值得所有内容平台学习。虽然有时因为核实过程导致发布稍有延迟，但"宁缺毋滥"的原则值得肯定。',
    date: '2026-05-10',
    userType: '合作媒体',
  },
];